<template>
  <div>
    <div class="page-title-container lighter-shadow">
      <i class="fas fa-users icon"></i>
      <h1>Състав</h1>
      <LiteButton class="add-button"
                  v-if="isUserAdmin"
                  @click.native="addWorkerClicked"
                  :hoverColor="'green'"
                  :icon="'fas fa-user-plus'"
                  :text="'Добавяне'">
      </LiteButton>
    </div>
    <div class="additional-filters-container">
      <ProfessionDropdown class="additional-filter" :id="'professionDropdown'" :label="'Професия'"
                          @selection-change="filterByProfession"/>
      <TeamDropdown class="additional-filter" :id="'teamDropdown'" :label="'Екип'" @selection-change="filterByTeam"/>
    </div>
    <Grid class="worker-list-grid"
          :config="config"
          :gridData="gridData"
          :loading="isLoading"
          @row-clicked="rowClicked">
    </Grid>
  </div>
</template>

<script>
import Grid from "@/shared/components/grid/Grid";
import workerListGridConfig from "@/components/worker/worker-list-grid.config";
import workerService from "@/services/worker.service"
import redirectService from "@/services/redirect.service";
import LiteButton from "@/shared/components/button/LiteButton";
import {mapGetters} from "vuex";
import {cloneDeep} from 'lodash';

export default {
  name: "WorkerList",
  components: {LiteButton, Grid},
  created() {
    this.fetchWorkers(null);
  },
  data() {
    return {
      config: workerListGridConfig,
      gridDataInitial: [],
      gridData: [],
      isLoading: true
    }
  },
  methods: {
    addWorkerClicked() {
      redirectService.redirectToAddWorker();
    },
    rowClicked(row) {
      redirectService.redirectToWorkerProfile(row.id);
    },
    filterByProfession({currentValueId}) {
      const initialData = cloneDeep(this.gridDataInitial);
      console.log(currentValueId);
      if (currentValueId) {
        this.gridData = initialData.filter(({professions}) => professions.map(({id}) => id).includes(currentValueId));
      } else {
        this.gridData = initialData;
      }
    },
    filterByTeam({currentValueId}) {
      if (currentValueId) {
        this.fetchWorkers(currentValueId);
      } else {
        this.fetchWorkers(null);
      }
    },
    fetchWorkers(teamId) {
      workerService.fetchWorkers(teamId)
          .then(({data}) => {
            if (data) {
              this.gridDataInitial = cloneDeep(data);
              this.gridData = data;
              this.isLoading = false;
            }
          });
    }
  },
  computed: {
    ...mapGetters(['isUserAdmin'])
  }
}
</script>

<style scoped>
.add-button {
  width: 350px;
  float: right;
  margin: 35px 0;
  font-size: 25px;
  color: var(--primary-blue);
}

.worker-list-grid {
  margin: 30px auto 0 auto;
  display: inline-block;
  max-width: 100%;
}

.additional-filters-container {
  width: 100%;
  height: auto;
  display: flex;
  justify-content: start;
}

.additional-filters-container .additional-filter {
  width: 25%;
  min-width: 300px;
  margin-right: 60px;
}
</style>
